// Configuration des variables d'environnement
export const config = {
  supabase: {
    url: import.meta.env.VITE_SUPABASE_URL,
    anonKey: import.meta.env.VITE_SUPABASE_ANON_KEY,
  },
  woocommerce: {
    url: import.meta.env.VITE_WOO_API_URL,
    consumerKey: import.meta.env.VITE_WOO_CONSUMER_KEY,
    consumerSecret: import.meta.env.VITE_WOO_CONSUMER_SECRET,
  },
  backup: {
    url: import.meta.env.VITE_BACKUP_API_URL || 'https://live.lotismode.com/backup',
  }
} as const;

// Validation de la configuration
export const validateConfig = () => {
  const { supabase, woocommerce } = config;

  // Utiliser toujours en priorité les valeurs d'environnement pour l'API REJOO
  const supabaseUrl = supabase.url;
  const supabaseAnonKey = supabase.anonKey;

  // Vérification de la configuration Supabase
  if (!supabaseUrl) {
    console.error('URL Supabase manquante');
    throw new Error('URL Supabase manquante');
  }

  if (!supabaseAnonKey) {
    console.error('Clé anonyme Supabase manquante');
    throw new Error('Clé anonyme Supabase manquante');
  }

  // Vérification de l'URL avec plus de détails si problème
  try {
    new URL(supabaseUrl);
  } catch (e) {
    console.error(`Format d'URL Supabase invalide: ${supabaseUrl}`, e);
    throw new Error(`Format d'URL Supabase invalide: ${supabaseUrl}`);
  }

  // Vérification de la clé
  if (supabaseAnonKey.length < 20) {
    console.warn('La clé anonyme Supabase semble trop courte, elle pourrait être invalide');
  }
  
  // Afficher les informations de la configuration (sans les clés sensibles)
  console.log('Configuration validée:', {
    supabaseUrl: supabaseUrl,
    woocommerceUrl: woocommerce.url,
    hasSupabaseKey: !!supabaseAnonKey,
    hasWooKeys: !!(woocommerce.consumerKey && woocommerce.consumerSecret),
    isDefaultConfig: supabaseUrl === 'https://api.rejoo.be'
  });

  // Vérification de la configuration WooCommerce
  if (!woocommerce.url || !woocommerce.consumerKey || !woocommerce.consumerSecret) {
    console.warn('Configuration WooCommerce incomplète');
  }
};